import { useFinchConnect } from '@tryfinch/react-connect';

import { ZIndex } from '@neo.tax/shared/utils';

import { FinchErrorCallback, FinchSuccessCallback } from '../finch.types';

const noop = (): void => {};

export const useFinch = (
  sessionId: string,
  onSuccess: FinchSuccessCallback,
  onError: FinchErrorCallback,
  onClose: () => void = noop,
): { open: () => void } =>
  useFinchConnect({
    sessionId,
    onSuccess,
    onError,
    onClose,
    // This is necessary because of allocation page's zIndex
    zIndex: ZIndex.TROUSER_MODAL,
  });
